// hooks/useLowStockProducts.js
import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export const useLowStockProducts = (token) => {
  const [lowStockProducts, setLowStockProducts] = useState([]);

  useEffect(() => {
    const fetchLowStockProducts = async () => {
      try {
        const { data } = await axios.get("/api/v1/product/get-product");

        if (data?.success) {
          const lowStock = data.products.filter(
            (product) => product.stock <= 5 && product.stock > 0
          );
          const outOfStock = data.products.filter(
            (product) => product.stock === 0
          );

          setLowStockProducts([...lowStock, ...outOfStock]);

          if (lowStock.length > 0) {
            toast.error(`${lowStock.length} product(s) running low on stock!`, {
              duration: 5000,
            });
          }
          if (outOfStock.length > 0) {
            toast.error(`${outOfStock.length} product(s) out of stock!`, {
              duration: 5000,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    if (token) {
      fetchLowStockProducts();
    }
  }, [token]);

  return { lowStockProducts };
};
